import { BannerSliderProps } from "@omni/types/components/props/bannerSlider.props";
import { cn } from "@omni/utils/styles";

import { BannerSlider } from "./bannerSlider";

const BannerSliderDefault = (props: BannerSliderProps) => {
    return (
        <BannerSlider {...props}>
            <BannerSlider.Slider>
                <BannerSlider.Content />
            </BannerSlider.Slider>
            <div
                className={cn(
                    "tw:flex tw:gap-2 tw:flex-row",
                    "tw:mb-4",
                    "tw:md:mb-0"
                )}
            >
                <div
                    className={cn(
                        "tw:flex-1 tw:gap-1 tw:flex tw:justify-center tw:items-center"
                    )}
                >
                    <BannerSlider.ProgressBar>
                        <BannerSlider.ProgressBar.Bar />
                    </BannerSlider.ProgressBar>
                </div>
                <div className={cn("tw:content-end")}>
                    <BannerSlider.ProgressBar.Button />
                </div>
            </div>
        </BannerSlider>
    );
};

export { BannerSliderDefault };
